"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Icon Left",
    "clip-path": "url(#clip0_13999_28688)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Shape",
    d: "M0.5 4.3C0.5 3.02975 1.45939 2 2.64286 2H13.3571C14.5406 2 15.5 3.02974 15.5 4.3V11.2C15.5 12.4703 14.5406 13.5 13.3571 13.5H2.64286C1.45939 13.5 0.5 12.4703 0.5 11.2V4.3ZM13.3571 12.35C13.9489 12.35 14.4286 11.8351 14.4286 11.2V7.75H6.61476L7.84309 9.06841C8.0523 9.29296 8.0523 9.65703 7.84309 9.88159C7.63388 10.1061 7.29469 10.1061 7.08548 9.88159L5.85714 8.56317V12.35H13.3571ZM7.90855 6.6H14.4286V4.3C14.4286 3.66487 13.9489 3.15 13.3571 3.15H5.85714V4.39816C6.0247 4.33459 6.20502 4.3 6.39286 4.3C7.28046 4.3 8 5.07231 8 6.025C8 6.22661 7.96777 6.42015 7.90855 6.6ZM6.39286 6.6C6.68872 6.6 6.92857 6.34256 6.92857 6.025C6.92857 5.70744 6.68872 5.45 6.39286 5.45C6.09699 5.45 5.85714 5.70744 5.85714 6.025V6.6H6.39286ZM4.78571 4.39816V3.15H2.64286C2.05112 3.15 1.57143 3.66487 1.57143 4.3V6.6H2.73431C2.67508 6.42015 2.64286 6.22661 2.64286 6.025C2.64286 5.07231 3.3624 4.3 4.25 4.3C4.43784 4.3 4.61815 4.33459 4.78571 4.39816ZM4.25 6.6H4.78571V6.025C4.78571 5.70744 4.54587 5.45 4.25 5.45C3.95413 5.45 3.71429 5.70744 3.71429 6.025C3.71429 6.34256 3.95413 6.6 4.25 6.6ZM4.0281 7.75H1.57143V11.2C1.57143 11.8351 2.05112 12.35 2.64286 12.35H4.78571V8.56317L3.55738 9.88159C3.34817 10.1061 3.00897 10.1061 2.79976 9.88159C2.59056 9.65703 2.59056 9.29296 2.79976 9.06841L4.0281 7.75Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_13999_28688"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: size,
    height: size,
    fill: "white",
    transform: "translate(0.5)"
  }))));
};

exports["default"] = _default;